// extracted by mini-css-extract-plugin
export default {"wrapper":"Cz-z","viewport":"Dz-z","container":"Ez-z","slide":"Fz-z"};